// extracted by mini-css-extract-plugin
module.exports = {"fieldWithIcon":"FieldIcon_fieldWithIcon__1YHwu","iconWrapper":"FieldIcon_iconWrapper__ijh58","icon":"FieldIcon_icon__3CgBC"};